<template>
    <div>
        <Form :model="formItem" ref="formItemSearch" :label-width="60">
            <Row>
                <Col span="24">
                    <Col span="4">
                        <FormItem label="关键字" prop="keywords">
                            <Input v-model="formItem.keywords" placeholder="姓名/手机号" @keydown.native.enter.prevent="search"></Input>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="角色" prop="role_id">
                            <Select v-model="formItem.role_id">
                                <Option v-for="item in roleList" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="部门" prop="department_id">
                            <Select v-model="formItem.department_id" @on-change="departmentChange">
                                <Option v-for="item in departmentList" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="职位" prop="position_id">
                            <Select v-model="formItem.position_id">
                                <Option v-for="item in positionList" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="员工状态" :label-width="80" prop="state">
                            <Select v-model="formItem.state">
                                <Option value="1">在职</Option>
                                <Option value="2">离职</Option>
                                <Option value="3">调店</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="内部通知单默认接收状态" :label-width="160" prop="inside_notice_state">
                        <Select v-model="formItem.inside_notice_state">
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <Button type="primary" style="margin-left:5px" @click="search">查询</Button>
                    <Button type="primary" @click="reset('formItemSearch')">清空筛选</Button>
                    <Button type="primary" @click="add">添加</Button>
                </Col>
            </Row>
        </Form>
        <div style="width:100%">
            <Table ref="table" stripe :loading="loading" border :columns="t_head" :data="t_data" :height="tableHeight"></Table>
            <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page :total="pagination.total" :page-size="pagination.per_page" show-total show-elevator show-sizer  @on-page-size-change="changeLimit"  @on-change="pageChange" :transfer="true" :page-size-opts="pageSizeOpts"/>
            </div>
        </div>
        <Modal
            v-model="staffModalShow"
            :title="staffModaltitle">
            <Alert type="success">
                小提示：{{desc}}
            </Alert>
            <Form ref="formValidate" :model="staffFormItem" :rules="ruleValidate" :label-width="80">
                <FormItem label="姓名" prop="user_name">
                    <Input v-model="staffFormItem.user_name" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="账号" prop="phone">
                    <Input v-model="staffFormItem.phone" placeholder="请输入" :maxlength="11"></Input>
                </FormItem>
                <FormItem label="选择部门" prop="department_id">
                    <Select v-model="staffFormItem.department_id" @on-change="departmentChangeEdit">
                        <Option v-for="item in departmentList" :key="item.id" :value="item.id+''">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="选择职位" prop="position_id">
                    <Select v-model="staffFormItem.position_id">
                        <Option v-for="item in positionList" :key="item.id" :value="item.id+''">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="选择角色" prop="role_id">
                    <Select v-model="staffFormItem.role_id">
                        <Option v-for="item in roleList" :key="item.id" :value="item.id+''">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="close">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit ('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'staffList',
    data(){
        return{
            tableHeight: 500,
            pageSizeOpts:[50,60,70,80,90,100],
            loading:false,
            staffModalShow:false,
            staffModaltitle:'',
            formItem:{
                limit:50,
                keywords:'',
                role_id:'',
                department_id:'',
                position_id:'',
                state:'',
                inside_notice_state:'',
                page:1
            },
            staffFormItem:{
                user_name:'',
                phone:'',
                department_id:'',
                position_id:'',
                role_id:''
            },
            desc:'',
            ruleValidate:{
                user_name: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                department_id: [
                    { required: true,  message: '请选择', trigger: 'change' }
                ],
                position_id: [
                    { required: true,  message: '请选择', trigger: 'change' }
                ],
                role_id: [
                    { required: true,  message: '请选择', trigger: 'change' }
                ]
            },
            t_head: [
                {
                    width: 60,
                    align: 'center',
                    title:"序号",
                    render: (h,params) => {
                        return h('span',
                        (params.index + 1) + (this.pagination.per_page * (this.pagination.current_page-1)))
                    }
                },
                {
                    title: '姓名',
                    key: 'user_name',
                    align: 'center',
                },
                {
                    title: '手机号码',
                    key: 'phone',
                    align: 'center',
                },
                {
                    title: '部门',
                    key: 'department_name',
                    align: 'center',
                },
                {
                    title: '职位',
                    key: 'position_name',
                    align: 'center',
                },
                {
                    title: '授权角色',
                    key: 'role_name',
                    align: 'center',
                },
                {
                    title: '员工状态',
                    key: 'state_text',
                    align: 'center',
                    render: (h, params) => {
                        let status = params.row.state
                        let get_color = ''
                        if(status === 1){
                            get_color = "primary"
                            return h('div', [
                            h('Button', {
                                props: {
                                    type: get_color,
                                    size: 'small'
                                },
                            }, params.row.state_text),
                        ]);
                        }else if(status === 2){
                            get_color = "error"
                        }else if(status === 3){
                            get_color = "warning"
                        }
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: get_color,
                                    size: 'small'
                                },
                            }, params.row.state_text),
                            h('span', {
                            }, '('+params.row.resignation_time+')')
                        ]);
                    }
                },
                {
                    title: '内部通知单默认接收状态',
                    key: 'inside_notice_state_text',
                    align: 'center',
                    render: (h, params) => {
                        let status = params.row.inside_notice_state
                        let get_color = ''
                        if(status === 1){
                            get_color = "primary"
                        }else if(status === 0){
                            get_color = "error"
                        }
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: get_color,
                                    size: 'small'
                                },
                            }, params.row.inside_notice_state_text)
                        ]);
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row.id)
                                    }
                                }
                            }, '编辑')
                        ]);
                    }
                }
            ],
            t_data: [],
            pagination:{},
            departmentList:[],
            positionList:[],
            roleList:[],
            listDetailId:0
        }
    },
    created(){
        this.apiDepartmentAll()
        this.apiRoleAll()
        this.apiStaffList()
    },
    mounted(){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 205
    },
    methods: {
        changeLimit(val){
            this.formItem.limit=val
            this.apiStaffList()
        },
        apiDepartmentAll(){
            serve.fetchGet(api.agentDepartment,{}).then(data => {
                console.log(data)
                this.departmentList = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPositionAll(departmeny_id,position_id){
            serve.fetchGet(api.agentPosition,{department_id:departmeny_id}).then(data => {
                console.log(data)
                this.positionList = data.data
                if(position_id){
                    this.staffFormItem.position_id = position_id
                }
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiRoleAll(){
            serve.fetchGet(api.agentRole,{}).then(data => {
                console.log(data)
                this.roleList = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiStaffList(){
            this.loading = true
            serve.fetchGet(api.agent,this.formItem).then(data => {
                console.log(data)
                this.t_data = data.data
                this.pagination = data.meta.pagination
                this.loading = false
            }).catch((error)=>{
                this.loading = false
                this.$Message.error(error.response.data.message);
            })
        },
        apiStaffAdd(){
            serve.fetchPost(api.agent,this.staffFormItem).then(data => {
                console.log(data)
                this.$Message.success('添加成功');
                this.staffModalShow = false
                this.apiStaffList() 
            }).catch((error)=>{
                console.log(error.response)
                this.$Message.error(error.response.data.message);
            })
        },
        apiStaffDetail(id){
            serve.fetchGet(api.agent+'/'+id,{}).then(data => {
                console.log(data)
                this.staffFormItem.user_name = data.data.user_name
                this.staffFormItem.phone = data.data.phone
                this.staffFormItem.department_id = data.data.department_id+''
                this.apiPositionAll(data.data.department_id,data.data.position_id+'')
                this.staffFormItem.role_id = data.data.role_id+''
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiStaffEdit(){
            serve.fetchPut(api.agent+"/"+this.listDetailId,this.staffFormItem).then(data => {
                console.log(data)
                this.$Message.success('编辑成功');
                this.staffModalShow = false
                this.apiStaffList() 
            }).catch((error)=>{
                console.log(error.response)
                this.$Message.error(error.response.data.message);
            })
        },
        add(){
            this.$refs.formValidate.resetFields()
            this.desc = '账号必须是员工手机号,密码默认为123456！'
            this.staffModaltitle = '添加员工'
            this.staffModalShow = true
        },
        edit(id){
            this.$refs.formValidate.resetFields()
            this.desc = '定制账号的管理权限，适当的分担责任！'
            this.staffModaltitle = '编辑员工'
            this.staffModalShow = true
            this.listDetailId = id
            this.apiStaffDetail(id)
        },
        close(){
            this.staffModalShow = false
            this.adjustStoreModalShow = false
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // this.$Message.success('Success!');
                    if(this.staffModaltitle === '添加员工'){
                        this.apiStaffAdd()
                        return
                    }
                    this.apiStaffEdit()
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        pageChange(page){
            console.log(page)
            this.formItem.page = page
            this.apiStaffList()
        },
        search(){
            this.formItem.page = 1
            console.log(this.formItem)
            this.apiStaffList()
        },
        reset(name){  
            this.formItem.page = 1
            this.$refs[name].resetFields();
            this.apiStaffList()               
        },
        departmentChange(departmeny_id){
            console.log(name)
            this.formItem.position_id = ''
            this.apiPositionAll(departmeny_id)
        },
        departmentChangeEdit(departmeny_id){
            this.staffFormItem.position_id = ''
            this.apiPositionAll(departmeny_id)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/SystemSetting/System/staffList.vue